document.addEventListener('DOMContentLoaded', () => {
    const cta = document.querySelector('.js-button');
    if (cta) {
      setTimeout(() => {
        cta.classList.add('is-show');
      }, 300);
    }
  });
  